'use strict';

var _Version = require('../Version');

var _Version2 = _interopRequireDefault(_Version);

var _unit = require('unit.js');

var _unit2 = _interopRequireDefault(_unit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
describe('my suite', () => {
  // test cases
  it('my test', () => {
    // should set the timeout of this test to 1000 ms; instead will fail
    this.timeout(1000);
    assert.ok(true);
  });
});

describe.only // Only test this suite
describe.skip // Skip this suite
it.only // Only test this test
it.skip // Skip test this test

before // before the test suite
after // after the test suite
beforeEach // before the each test case
AfterEach // after the each test case

describe('Array', function() {
  describe('#indexOf()', function() {
    it.skip('should return -1 unless present', function() {
      // this test will not be run
    });

    it('should return the index when present', function() {
      // this test will be run
    });
  });
});

 */

// test suite
describe('Version', function () {
    // test case
    it('should be parsed correctly', function () {
        var v = new _Version2.default();
        _unit2.default.number(v.major).is(0);
        _unit2.default.number(v.minor).is(0);
        _unit2.default.number(v.revision).is(0);

        v = new _Version2.default('1');
        _unit2.default.number(v.major).is(1);
        _unit2.default.number(v.minor).is(0);
        _unit2.default.number(v.revision).is(0);

        v = new _Version2.default('1.1');
        _unit2.default.number(v.major).is(1);
        _unit2.default.number(v.minor).is(1);
        _unit2.default.number(v.revision).is(0);

        v = new _Version2.default('1.1.1');
        _unit2.default.number(v.major).is(1);
        _unit2.default.number(v.minor).is(1);
        _unit2.default.number(v.revision).is(1);
    });

    it('should be parsed with expected exception', function () {
        _unit2.default.exception(function () {
            new _Version2.default('a');
        });
        _unit2.default.exception(function () {
            new _Version2.default('1.a');
        });
        _unit2.default.exception(function () {
            new _Version2.default('1.1.a');
        });
    });
});
//# sourceMappingURL=testVersion.js.map